import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import HobnobModal from 'src/components/common/HobnobModalV2/HobnobModal'
import OverlayLoadingIndicator from 'components/common/OverlayLoadingIndicator'

import NoInvitationRSVPView from '../rsvp_modal/NoInvitationRSVPView'
import {
  loginFormSelector
} from 'src/selectors'

import styles from './rsvp-by-host-modal-container.scss'

import RSVPByHostUndecidedToAccepted from './RSVPByHostUndecidedToAccepted'
import RSVPByHostDeclinedToAccepted from './RSVPByHostDeclinedToAccepted'
import RSVPByHostAccepted from './RSVPByHostAccepted'
import UpdateGuestCountView from './UpdatGuestCountView'
import { showHud } from 'src/actions/frontend'

class RSVPByHostModalContainer extends Component {
  _verifyInvitationGuest = (ticketCounts) => {
    const {
      event: { max_capacity, limit_per_invitation },
      eventTicketCounts,
      ticketTypes,
      invitation: { id: guestId },
      onShowHud
    } = this.props

    const activeTicketTypes = ticketTypes.filter(item => !item.archived_at)
    const activeTypeIds = activeTicketTypes.map(item => item.id)

    const otherAcceptedInvitations = eventTicketCounts.invitations.filter(invitation => invitation.rsvp_state === 'accepted' && invitation.id !== guestId)

    const otherGuest = otherAcceptedInvitations.reduce((sum, invitation) => {
      const invitationTicketCounts = invitation.ticket_counts.filter(tc => {
        return activeTypeIds.includes(tc.ticket_type_id)
      })
      const invitationTotal = invitationTicketCounts.reduce((acc, ticket) => acc + ticket.ticket_count, 0)
      return sum + invitationTotal
    }, 0)

    const totalTickets = ticketCounts.reduce((acc, ticket) => ticket.count + acc, 0)

    if (limit_per_invitation !== 9999 && totalTickets > limit_per_invitation) {
      onShowHud(` This Event allows a maximum of ${limit_per_invitation} Guest(s) per invitation`)
      return false
    }

    if (max_capacity !== 9999 && totalTickets + otherGuest > max_capacity) {
      onShowHud(`Your RSVP exceeds the event's maximum capacity`)
      return false
    }

    return true
  }
  _onAcceptInvitationFromUndecided = ({ rsvpState, ticketCounts, onSuccess }) => {
    const { onSave, onSetRequestedRsvp, onInputTicketCountsChange } = this.props

    if (rsvpState === 'accepted' && !this._verifyInvitationGuest(ticketCounts)) return

    if (onSuccess) {
      onSuccess()
    }

    onSetRequestedRsvp(rsvpState)
    onInputTicketCountsChange(ticketCounts)

    onSave(
      {
        rsvpState: rsvpState,
        ticketCounts
      }
    )
  }

  _renderRsvpView() {
    const {
      requestedRsvp,
      event,
      ticketTypesCounts,
      loginForm,
      displayName,
      ticketCounts,
      onInputTicketCountsChange,
      listMyOrdersForEvent
    } = this.props

    let { invitation } = this.props
    if (!invitation || (invitation && loginForm.loginStep === 'fullName')) {
      return <NoInvitationRSVPView requestedRsvp={requestedRsvp} guestName={displayName} />
    }

    if (invitation.rsvp_state === 'undecided' && requestedRsvp === 'accepted') {
      return (
        <RSVPByHostUndecidedToAccepted
          displayName={displayName}
          guestCountEnabled={event.guest_count_enabled}
          childCountEnabled={event.child_count_enabled}
          initialGuestCount={invitation.guest_count}
          initialChildCount={invitation.child_count}
          onConfirm={this._onAcceptInvitationFromUndecided}
          ticketCounts={ticketCounts}
          ticketTypesCounts={ticketTypesCounts}
          onChangeCount={onInputTicketCountsChange}
        />
      )
    }

    if (invitation.rsvp_state === 'accepted') {
      return (
        <RSVPByHostAccepted
          displayName={displayName}
          event={event}
          ticketCounts={ticketCounts}
          onConfirm={this._onAcceptInvitationFromUndecided}
          listMyOrdersForEvent={listMyOrdersForEvent}
        />
      )
    }

    if (invitation.rsvp_state === 'declined') {
      return (
        <RSVPByHostDeclinedToAccepted
          displayName={displayName}
          event={event}
          onConfirm={this._onAcceptInvitationFromUndecided}
          ticketCounts={ticketCounts}
          ticketTypesCounts={ticketTypesCounts}
        />
      )
    }
  }

  _renderLoadingView() {
    return (
      <div className={styles['loading-container']}>
        <OverlayLoadingIndicator loading light />
        Loading...
      </div>
    )
  }

  _renderUpdateGuestCountView() {
    return (
      <UpdateGuestCountView
        childCountEnabled={this.props.event.child_count_enabled}
        displayName={this.props.displayName}
        ticketCounts={this.props.ticketCounts}
        onConfirm={(value) => this._onAcceptInvitationFromUndecided({ ...value, rsvpState: 'accepted' })}
      />
    )
  }

  render() {
    const { visible, onClose, showUpdateGuestCount } = this.props

    return (
      <HobnobModal visible={visible} onCancel={onClose} maskClosable={false}>
        <div className={styles['rsvp-modal-container']}>
          {

            showUpdateGuestCount ? this._renderUpdateGuestCountView() : this._renderRsvpView()
          }
        </div>
      </HobnobModal>
    )
  }
}

RSVPByHostModalContainer.propTypes = {
  loginForm: PropTypes.object,
  event: PropTypes.object,
  invitation: PropTypes.object,
  requestedRsvp: PropTypes.string,
  visible: PropTypes.bool,
  ticketTypesCounts: PropTypes.array,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  onSetRequestedRsvp: PropTypes.func,
  displayName: PropTypes.string,
  ticketCounts: PropTypes.array,
  onInputTicketCountsChange: PropTypes.func,
  listMyOrdersForEvent: PropTypes.array,
  onShowHud: PropTypes.func,
  showUpdateGuestCount: PropTypes.bool,
  eventTicketCounts: PropTypes.object,
  ticketTypes: PropTypes.array
}

function mapStateToProps(state) {
  return {
    userId: state.userId,
    loginForm: loginFormSelector(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onShowHud: message => dispatch(showHud('error', message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RSVPByHostModalContainer)
